import React, { useEffect, useState } from 'react';
import { api } from '../../../config';
import { Link, useParams } from 'react-router-dom';
import {
   getStudentResult as onGetStudentResult,
   saveResultPdf as onSaveResultPdf
} from '../../../slices/result/thunk';
import {
   questionListResetFlag as onQuestionListResetFlag,
   questionSaveResetFlage as onQuestionSaveResetFlage
} from '../../../slices/exam/thunk';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { useTranslation } from 'react-i18next';
import '../../../App.css';
import '../../../assets/custom/results-responsive.css';
import Loader from '../../../Components/Common/Loader';

function RTAStudentResults() {

   const selectResultState = (state) => state.ResultReducer;
   const dispatch = useDispatch();
   const [storedData, setStoredData] = useState([]);
   const mediaSource = api.IMAGE_URL;
   const navigate = useNavigate();
   let { examid, type } = useParams();
   const [trafficId, setTrafficId] = useState('');

   const { t, i18n } = useTranslation();
   const [direction, setDirection] = useState('ltr');
   const [defaultLocale, setDefaultLocale] = useState('en');

   const resultProperties = createSelector(
      selectResultState,
      (data) => ({
         resultList: data.resultList,
         isResultSuccess: data.isResultSuccess,
         error: data.error,
         isLoading: data.isLoading
      })
   );

   const { resultList, error, isResultSuccess, isLoading } = useSelector(resultProperties);

   const [time, setTime] = useState({
      hours: 0,
      minutes: 5,
      seconds: 0,
   });

   useEffect(() => {
      setTrafficId(resultList && resultList.traffic_id);
   }, [resultList]);

   useEffect(() => {
      const postedResultData = { exam_id: examid };
      dispatch(onGetStudentResult(postedResultData));
   }, [dispatch]);

   useEffect(() => {
      const dataFromLocalStorage = localStorage.getItem('apiData');
      setStoredData(dataFromLocalStorage ? JSON.parse(dataFromLocalStorage) : null);
   }, []);

   const handleNavigation = () => {
      dispatch(onQuestionSaveResetFlage());
      const isRiderSelfRegister = localStorage.getItem('systemLocalIp') === 'rider-self-register';
      const entryPath = localStorage.getItem('registrationEntryPath') || '/rider-register';
      navigate(isRiderSelfRegister ? entryPath : '/student');
   };

   const handleTimeUp = () => {
      handleNavigation();
   };

   useEffect(() => {
      const timer = setInterval(() => {
         if (time.hours === 0 && time.minutes === 0 && time.seconds === 0) {
            clearInterval(timer);
            if (type === 'student') handleTimeUp();
         } else {
            setTime(prevTime => {
               let updatedHours = prevTime.hours;
               let updatedMinutes = prevTime.minutes;
               let updatedSeconds = prevTime.seconds - 1;

               if (updatedSeconds < 0) {
                  updatedSeconds = 59;
                  updatedMinutes--;

                  if (updatedMinutes < 0) {
                     updatedMinutes = 59;
                     updatedHours--;

                     if (updatedHours < 0) {
                        updatedHours = 0;
                        updatedMinutes = 0;
                        updatedSeconds = 0;
                     }
                  }
               }

               return {
                  hours: updatedHours,
                  minutes: updatedMinutes,
                  seconds: updatedSeconds,
               };
            });
         }
      }, 1000);

      return () => clearInterval(timer);
   }, [time]);

   const handlePrintPreview = () => {
      window.print();
   };

   useEffect(() => {
      if (type === 'student') {
         printPdfDocument();
      }
   }, [type]);

   const printPdfDocumentOld = () => {
      const pdfButton = document.getElementById('pdf-button');


      if (pdfButton) pdfButton.style.display = 'none';

      const input = document.getElementById('divToPdf');
      html2canvas(input, {
         scale: 2,
         useCORS: true,
         logging: true,
         letterRendering: true,
      }).then((canvas) => {
         const imgWidth = 210;
         const imgHeight = (canvas.height * imgWidth) / canvas.width;
         const pageHeight = 297;
         let heightLeft = imgHeight;

         const imgData = canvas.toDataURL('image/jpeg', 1.7); // Adjust quality to reduce file size
         let position = 0;

         const pdf = new jsPDF('p', 'mm', 'a4');
         pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight, undefined, 'FAST'); // Use 'FAST' compression

         heightLeft -= pageHeight;

         while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
            heightLeft -= pageHeight;
         }

         if (type === 'admin') {
            pdf.save(`${trafficId}.pdf`);
         }

         const pdfBlob = pdf.output('blob');
         callSavePdfApiFunction(pdfBlob);

         if (pdfButton) pdfButton.style.display = '';
      });
   };

const printPdfDocument = () => {
    const pdfButton = document.getElementById('pdf-button');
    if (pdfButton) pdfButton.style.display = 'none';

    const input = document.getElementById('divToPdf');

    const images = input.getElementsByTagName('img');
    const loadImagePromises = Array.from(images).map((img) => {
        return new Promise((resolve, reject) => {
            if (img.complete) {
                resolve();
            } else {
                img.onload = resolve;
                img.onerror = reject;
            }
        });
    });

    Promise.all(loadImagePromises).then(() => {
        html2canvas(input, {
            scale: 3,
            useCORS: true,
            logging: false
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/jpeg', 0.95);

            // Convert canvas size to mm
            const pxToMm = (px) => px * 25.4 / 96; // 96 DPI
            const pdfWidth = pxToMm(canvas.width);
            const pdfHeight = pxToMm(canvas.height);

            // Create PDF in landscape with custom size
            const pdf = new jsPDF('l', 'mm', [pdfWidth, pdfHeight]);

            pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);

            if (type === 'admin') {
                pdf.save(`${trafficId}.pdf`);
            }

            const pdfBlob = pdf.output('blob');
            callSavePdfApiFunction(pdfBlob);

            if (pdfButton) pdfButton.style.display = '';
        });
    }).catch((error) => {
        console.error('Error loading images:', error);
    });
};




   const callSavePdfApiFunction = (pdfParam) => {
      const formData = new FormData();
      formData.append('pdf', pdfParam);
      formData.append('trafficId', resultList && resultList.traffic_id);
      formData.append('examid', examid);

      dispatch(onSaveResultPdf(formData));
   };

   const handleChangeLocale = (currentLocale) => {
      if (currentLocale === 'en') {
         setDirection('ltr');
      } else {
         setDirection('rtl');
      }
      setDefaultLocale(currentLocale);
   };

   useEffect(() => {
      i18n.changeLanguage(defaultLocale);
   }, [defaultLocale]);

   return (
      <>
         <div className="container-fluid container-lg rta-results-page" id="divToPdf">
            <div className="page-content">
               <div className="">
                  <div className="card result-card">
                     <div className="card-body pt-3">
                        {isLoading ? <Loader /> :
                           <>
                              <div className="rta-results-sheet">

                                 <div className="rta-results-header">
                                    <div className="rta-results-logo rta-results-logo--left">
                                       <img src={mediaSource + 'government-of-dubai-logo.png'} alt="Government of Dubai Logo" />
                                    </div>
                                    <div className="rta-results-logo rta-results-logo--right">
                                       <img src={mediaSource + 'rta_dubai.png'} alt="RTA Logo" />
                                    </div>
                                 </div>

                                 <h3 className="rta-results-title">
                                    {t("theory_test_title", {
                                       courseName: resultList?.courseName,
                                       course: resultList?.course
                                    })}
                                 </h3>

                                 <div className="result-table-wrap">
                                    <table className="rta-detail-table" dir={direction}>
                                       <tbody>
                                          <tr>
                                             <td>{t("Date tested")}:</td>
                                             <td>{resultList?.test_date}</td>
                                          </tr>
                                          <tr>
                                             <td>{t("Candidate")}:</td>
                                             <td>{resultList?.std_name}</td>
                                          </tr>
                                          <tr>
                                             <td>{t("Candidate ID")}:</td>
                                             <td>{resultList?.traffic_id}</td>
                                          </tr>
                                          <tr>
                                             <td>{t("Registration ID")}:</td>
                                             <td>{resultList?.traffic_id}</td>
                                          </tr>
                                          <tr>
                                             <td>{t("Exam Series Code")}:</td>
                                             <td>{"000-" + resultList?.examId}</td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>

                                 <p className="rta-results-status" dir={direction}>
                                    {resultList?.status == 0
                                       ? t("Unfortunately, you have failed your exam.")
                                       : t("Congratulations, you have passed your exam.")}
                                 </p>

                                 {resultList?.topics?.length > 0 && (
                                    <div className="result-table-wrap">
                                       <table className="rta-topic-table" dir={direction}>
                                          <thead>
                                             <tr>
                                                <th>{t("Topic Area")}</th>
                                                <th>{t("Number of Incorrect Answers")}</th>
                                             </tr>
                                          </thead>
                                          <tbody>
                                             {resultList.topics.map(
                                                (item, key) =>
                                                   item.wrong_ans > 0 && (
                                                      <tr key={key}>
                                                         <td>{item.topic}</td>
                                                         <td>{item.wrong_ans}</td>
                                                      </tr>
                                                   )
                                             )}
                                          </tbody>
                                       </table>
                                    </div>
                                 )}

                                 <div className="result-table-wrap">
                                    <table className="rta-score-table" dir={direction}>
                                       <thead>
                                          <tr>
                                             <th>{t("Questions")}</th>
                                             <th>{t("Number of Questions")}</th>
                                             <th>{t("Minimum Correct Answers Required")}</th>
                                             <th>{t("Correct Answers")}</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          <tr>
                                             <td style={{ fontWeight: "bold" }}>
                                                {t("Delivery Rider Questions")}
                                             </td>
                                             <td>{resultList?.total_question}</td>
                                             <td>{resultList?.required_ans}</td>
                                             <td>{resultList?.correct_ans}</td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </div>

                              <div className="mt-4 mb-2 no-print result-actions" id="pdf-button">
                                 {type === 'student' ? (
                                    <>
                                       {
                                          resultList.resultDetailBtn == 1 ? (
                                             <Link to={`/result-detail/${resultList?.attemptId}/${resultList?.examType}/${resultList?.course}`} color="primary" ><Button color="primary">View Result Detail</Button></Link>
                                          ) : ""
                                       }
                                       <Button color="primary" onClick={() => handleNavigation()}>Close</Button>
                                    </>
                                 ) : (
                                    <>
                                       <Button color="primary" onClick={() => handlePrintPreview()}>Print</Button>
                                       <Button onClick={() => navigate(-1)} color="primary">Back</Button>
                                       <Button color="primary" onClick={() => printPdfDocument()}>PDF</Button>
                                       <Button color="primary" onClick={() => printPdfDocument()}>Resend</Button>
                                       <Button color="primary" onClick={() => handleChangeLocale('en')}>English</Button>
                                       <Button color="primary" onClick={() => handleChangeLocale('ae')}>Arabic</Button>
                                       {resultList && resultList.langShort !== 'en' && resultList.langShort !== 'ae' ?
                                          <Button color="primary" onClick={() => handleChangeLocale(resultList && resultList.langShort)}>{resultList && resultList.examLang}</Button>
                                          : ''}
                                    </>
                                 )}
                              </div>
                              <div className="rta-results-footer">
                                 {t("footer_note", {
                                    branchName: resultList?.branchName,
                                 })}
                              </div>
                           </>
                        }
                     </div>
                  </div>
               </div>
            </div>
         </div >
      </>
   );
}

export default RTAStudentResults;
